module.exports = __webpack_public_path__ + "static/img/pic23.c83a316.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic23.png
// module id = qzgd
// module chunks = 0